import * as Sentry from "@sentry/react";
const { VITE_FB_PIXEL_ACTIVE } = import.meta.env;

type FbqAction = "track";
type FbqEventType =
  | "AddPaymentInfo"
  | "CompleteRegistration"
  | "InitiateCheckout"
  | "Lead"
  | "PageView"
  | "Purchase"
  | "SubmitApplication";
export type FbqEventOptions = Record<string, unknown>;

declare global {
  interface Window {
    fbq: (
      action: FbqAction,
      eventType: FbqEventType,
      options?: FbqEventOptions,
    ) => void;
  }
}

const hasMarketingConsent = () => {
  const cookieYesConsent = window.getCkyConsent ? window.getCkyConsent() : null;
  const consentViaCookieYes =
    cookieYesConsent && cookieYesConsent.categories.advertisement;
  const noCmp = !window.getCkyConsent;

  return noCmp || consentViaCookieYes;
};

const fbqEventFactory =
  (action: FbqAction) =>
  (eventType: FbqEventType, options?: FbqEventOptions) => {
    if (!hasMarketingConsent()) {
      return;
    }

    if (!VITE_FB_PIXEL_ACTIVE) {
      console.log("FB Pixel not activated");
      return;
    }

    if (typeof window === "undefined") {
      Sentry.captureMessage("window object is undefined");
      return;
    }

    if (
      (window as Window).fbq === null ||
      (window as Window).fbq === undefined
    ) {
      console.log("FB Pixel not initialized");
      return;
    }

    try {
      (window as Window).fbq(action, eventType, options);
    } catch (e) {
      Sentry.captureException(e as any);
    }
  };

export const trackFbqEvent = fbqEventFactory("track");
